import type { ReactNode } from 'react'
import styles from './FormFieldRequiredLabel.module.css'

interface FormFieldRequiredLabelProps {
  label: ReactNode
  required?: boolean
}

export function FormFieldRequiredLabel({
  label,
  required = true,
}: FormFieldRequiredLabelProps) {
  return (
    <>
      {label}
      {required && <span className={styles.asterisk}> *</span>}
    </>
  )
}
